import { render } from "./EquipmentInfo.vue?vue&type=template&id=2b8a521a&scoped=true"
import script from "./EquipmentInfo.vue?vue&type=script&lang=js"
export * from "./EquipmentInfo.vue?vue&type=script&lang=js"

import "./EquipmentInfo.vue?vue&type=style&index=0&id=2b8a521a&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8a521a"]])

export default __exports__